/* eslint-disable jsx-a11y/label-has-associated-control */
import React, {
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react';
import MenuIcon from '@material-ui/icons/Menu';
import { NavLink, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import AccountCircle from '@material-ui/icons/AccountCircle';
import config from '@/configs/config';
import './header.css';
import { getUserDataFromLocalStorage } from '@/plugins/Auth/reducer';
import Routes from '../Routes';

const logo = (() => {
  const headerLogoUrlOverrider = config.headerLogoUrl || null;
  const Logo = styled(headerLogoUrlOverrider ? 'a' : NavLink)`
    display: inline-block;
    background-color: transparent;
    background-image: url("${config.RESOURCE_URI}logo.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    border-image: none;
    border: none;
    height: 40px;
    width: 40px;

    @media (min-width: 796px) {
      background-image: url("${config.RESOURCE_URI}logo_wide.png");
      height: 60px;
      width: 197px;
    }
  `;
  return (
    <Logo {...(
    headerLogoUrlOverrider ? {
      href: headerLogoUrlOverrider,
    } : {
      to: '/',
    }
  )}
    />
  );
})();

const UserIcon = styled(AccountCircle)`
  vertical-align: middle;
`;

export default () => {
  const [currentUser, setCurrentUser] = useState(null);
  const { pathname, search } = useLocation() || {};
  const routeName = (pathname || '').split('/')[1];
  const currentRoute = Routes[routeName];

  useEffect(() => {
    const onAuthChanged = () => {
      const user = getUserDataFromLocalStorage();
      if (user && Object.keys(user).length > 0) {
        setCurrentUser(user);
      } else if (user != null) {
        setCurrentUser(null);
      }
    };
    const menu = document.querySelector('#side-menu');
    const dropDown = document.querySelector('.userSection');

    onAuthChanged();

    document.addEventListener('authChanged', onAuthChanged);
    document.addEventListener('click', (e) => {
      if (!menu.contains(e.target)) menu.classList.remove('!fz-translate-x-0');
      if (!dropDown.contains(e.target)) dropDown.classList.remove('active');
    }, true);
  }, []);

  const openMenu = () => {
    const menu = document.querySelector('#side-menu');

    menu.classList.add('!fz-translate-x-0');
  };

  const toggleUserMenu = () => {
    const dropDown = document.querySelector('.userSection');

    dropDown.classList.toggle('active');
  };

  const closeMenu = () => {
    const menu = document.querySelector('#side-menu');
    const dropDown = document.querySelector('.userSection');

    menu.classList.remove('!fz-translate-x-0');
    dropDown.classList.remove('active');
  };

  const logButton = useMemo(() => (currentUser ? (
    <NavLink
      className={['logoutButton', config.headerLoginButtonStyleVariant || null].filter((d) => d).join(' ')}
      onClick={closeMenu}
      to="/auth/logout"
    >
      登出
    </NavLink>
  ) : (
    <NavLink
      className={['loginButton', config.headerLoginButtonStyleVariant || null].filter((d) => d).join(' ')}
      onClick={closeMenu}
      to={{
        pathname: '/register',
        state: { afterLoginUrl: pathname + search },
      }}
    >
      {config.headerLoginButtonStyleVariant === 'black-and-white' && (
        <UserIcon />
      )}
      會員登入
    </NavLink>
    )), [location, currentUser]); //eslint-disable-line

  const userSection = useMemo(() => (
    <div className="userSection">
      {currentUser ? (
        <>
          <div className="userSection-first" onClick={toggleUserMenu}>
            <img src={currentUser?.user?.pictureUrl} alt="" />
            <span>{currentUser?.user?.displayName || ''}</span>
          </div>
          <div className="userSection-second">
            <NavLink to="/user/profile" className="userSection-link" onClick={closeMenu}>編輯會員資料</NavLink>
            <NavLink to="/user/coupon" className="userSection-link userSection-coupon-link" onClick={closeMenu}>我的優惠券</NavLink>
            {
              (config.modules?.['pre-orders'] === false && config.modules?.['daily-fresh-pre-orders'] === false) ? null : (
                <NavLink to="/user/redeemCode" className="userSection-link userSection-coupon-link" onClick={closeMenu}>我的取貨碼</NavLink>
              )
            }
            <hr />
            {logButton}
          </div>
        </>
      ) : logButton }
    </div>
  ),
  [currentUser, logButton]);

  const generateItem = useCallback((
    className,
    route,
    exact,
  ) => route && (
    <NavLink
      className={className}
      draggable={false}
      exact={exact}
      onClick={closeMenu}
      to={route.path}
    >
      {route.title}
    </NavLink>
  ), []);

  return (
    <>
      <div
        className={`
          ${config.stickyHeader ? 'fz-sticky' : ''}
          ${config.themeBackgroundColor ? `md:fz-bg-[${config.themeBackgroundColor}]` : 'md:fz-bg-black'}
          fz-w-full fz-bg-white fz-top-0 fz-z-10
        `}
      >
        <div className="fz-container fz-m-auto fz-flex fz-items-center fz-h-[60px] fz-px-4 md:fz-p-0">
          <div className="fz-items-center fz-w-full fz-flex md:fz-justify-between md:[&>*]:fz-basis-0">
            <div className={`
              fz-flex-grow
              fz-hidden
              ${config.headerLogoAlignLeft ? 'md:fz-hidden' : 'md:fz-block'}
            `}
            >
              {generateItem('wf_header_item', Routes.menu)}
            </div>
            <div className="fz-flex-shrink-0 fz-block fz-mt-1 md:fz-mt-0">
              {logo}
            </div>
            <div className="md:fz-hidden fz-ml-2">{(currentRoute || {}).title || config.BrandNameTW}</div>
            <div className="fz-items-center fz-flex-grow fz-justify-end fz-hidden md:fz-flex">
              {
              config.hideAboutUsLinkFromHeader !== true && (
                config.aboutUsPageRedirectionInHeader
                  ? <a className="wf_header_item" href={config.aboutUsPageRedirectionInHeader}>{Routes.about_us.title}</a>
                  : generateItem('wf_header_item', Routes.about_us, true)
              )
            }
              {generateItem('wf_header_item', Routes.location)}
              {generateItem('', Routes.ec_search)}
              {generateItem('', Routes.ec_cart)}
              {userSection}
            </div>
            <div className="md:fz-hidden fz-ml-auto">
              <MenuIcon fontSize="large" onClick={openMenu} />
            </div>
          </div>
        </div>
      </div>
      <div
        id="side-menu"
        className={`
          ${config.themeBackgroundColor ? `fz-bg-[${config.themeBackgroundColor}]` : 'fz-bg-black'}
          fz-fixed
          fz-flex
          fz-flex-col
          fz-h-screen
          fz-items-stretch
          fz-p-8
          fz-right-0
          fz-text-center
          fz-top-0
          fz-transition-transform
          fz-translate-x-full
          fz-z-20
          md:fz-hidden
        `}
      >
        {userSection}
        <hr className="fz-w-full" />
        {generateItem('wf_header_item', Routes.menu)}
        {generateItem('wf_header_item', Routes.location)}
        {generateItem('', Routes.ec_search)}
        {generateItem('', Routes.ec_cart)}
        <div style={{ flex: 1 }} />
        <hr className="fz-w-full" />
        {
            config.hideAboutUsLinkFromHeader !== true && (
              config.aboutUsPageRedirectionInHeader
                ? <a className="wf_header_item" href={config.aboutUsPageRedirectionInHeader}>{Routes.about_us.title}</a>
                : generateItem('wf_header_item', Routes.about_us, true)
            )
          }
        {generateItem('wf_header_item', Routes.partner_location)}
        {generateItem('wf_header_item', Routes.partner_provider)}
        {generateItem('wf_header_item', Routes.partner_saas_pro)}
        {generateItem('wf_header_item', Routes.faq)}
        <hr className="fz-w-full" />
        {logButton}
      </div>
    </>
  );
};
